import initialState from './initialState';
import { reducer as fetchMembersReducer } from './fetchMembers';
import { reducer as fetchPhasesReducer } from './fetchPhases';
import { reducer as deleteProjectReducer } from './deleteProject';
import { reducer as saveProjectActionReducer } from './saveProjectAction';
import { reducer as fetchScopeByProjectReducer } from './fetchScopeByProject';
import { reducer as getNextProjectIdReducer } from './getNextProjectId';
import { reducer as fetchCurrenciesReducer } from './fetchCurrencies';
import { reducer as fetchCloseOutReducer } from './fetchCloseOut';
import { reducer as saveCloseOutReducer } from './saveCloseOut';
import { reducer as fetchResumeReducer } from './fetchResume';
import { reducer as cloneProjectReducer } from './cloneProject';
import { reducer as getCloseOutReportReducer } from './getCloseOutReport';

const reducers = [
  fetchMembersReducer,
  fetchPhasesReducer,
  deleteProjectReducer,
  saveProjectActionReducer,
  fetchScopeByProjectReducer,
  getNextProjectIdReducer,
  fetchCurrenciesReducer,
  fetchCloseOutReducer,
  saveCloseOutReducer,
  fetchResumeReducer,
  cloneProjectReducer,
  getCloseOutReportReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js